import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';
import { createCherishMessage } from '../api';
import '../styles/DonateRegistrationModal.css';

const DonateRegistrationModal = ({ isOpen, onClose, onSubmit }) => {
  const [selectedFlower, setSelectedFlower] = useState(0);
  const [message, setMessage] = useState('');

  const flowerImages = [
    '/images/d2.png',
    '/images/d3.png',
    '/images/d11.png',
    '/images/d12.png',
    '/images/d13.png',
    '/images/d21.png',
    '/images/photo2.png'
  ];

  const handleFlowerSelect = (index) => {
    setSelectedFlower(index);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const selectedPersonData = localStorage.getItem('selectedPersonData');
    let customerName = '이추모';
    let goinId = null;
    
    if (selectedPersonData) {
      try {
        const personData = JSON.parse(selectedPersonData);
        customerName = personData.customerName || '이추모';
        goinId = personData.goinId || null;
      } catch (error) {
        customerName = '이추모';
      }
    }

    try {
      const apiData = {
        cherishId: 0,
        goinId: goinId || 0,
        flowerId: selectedFlower,
        title: `헌화 - ${customerName}`,
        content: message,
        secureFlag: 'Y'
      };

      const response = await createCherishMessage(apiData);
      
      if (response && response.status === 200) {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const currentDate = `${year}.${month}.${day}`;
        
        const donationData = {
          flowerImage: flowerImages[selectedFlower],
          message: message,
          customerName: customerName,
          date: currentDate,
          id: `api_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
        };
        
        if (onSubmit) {
          onSubmit(donationData);
        } else {
          const donationsKey = `donations_${customerName}`;
          const existingDonations = localStorage.getItem(donationsKey);
          let donations = [];
          
          if (existingDonations) {
            try {
              donations = JSON.parse(existingDonations);
            } catch (error) {
              donations = [];
            }
          }
          
          donations.unshift(donationData);
          localStorage.setItem(donationsKey, JSON.stringify(donations));
          
          window.dispatchEvent(new CustomEvent('donationUpdated', {
            detail: {
              customerName: customerName,
              donationData: donationData
            }
          }));
        }
        
        setSelectedFlower(0);
        setMessage('');
        onClose();
      } else {
        alert('헌화 등록에 실패했습니다. 다시 시도해주세요.');
      }
    } catch (error) {
      console.log('API error:', error);
      alert('헌화 등록에 실패했습니다. 다시 시도해주세요.');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="donate-registration-modal-overlay-unique">
      <div className="donate-registration-modal-unique">
        <div className="donate-registration-modal-header-unique">
          <h2 className="donate-registration-modal-title-unique">헌화선택</h2>
          <button className="donate-registration-modal-close-unique" onClick={onClose}>
            <FiX />
          </button>
        </div>

        <div className="donate-registration-modal-divider-unique"></div>

        <form className="donate-registration-modal-form-unique" onSubmit={handleSubmit}>
          {/* Flower Selection Grid */}
          <div className="donate-registration-modal-flower-section-unique">
            <div className="donate-registration-modal-flower-grid-unique">
              {flowerImages.map((image, index) => (
                <div key={index} className="donate-registration-modal-flower-item-unique">
                  <div className="donate-registration-modal-flower-image-container-unique">
                    <img 
                      src={image} 
                      alt={`Flower ${index + 1}`}
                      className="donate-registration-modal-flower-image-unique"
                      onError={(e) => {
                        e.target.src = '/images/d1.png';
                      }}
                    />
                  </div>
                  <label className="donate-registration-modal-radio-label-unique">
                    <input
                      type="radio"
                      name="flower"
                      value={index}
                      checked={selectedFlower === index}
                      onChange={() => handleFlowerSelect(index)}
                      className="donate-registration-modal-radio-unique"
                    />
                    <span className="donate-registration-modal-radio-custom-unique"></span>
                  </label>
                </div>
              ))}
            </div>
          </div>

          {/* Message Input Section */}
          <div className="donate-registration-modal-message-section-unique">
            <h3 className="donate-registration-modal-message-title-unique">전하실 말씀</h3>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="donate-registration-modal-message-textarea-unique"
            />
          </div>

          {/* Action Buttons */}
          <div className="donate-registration-modal-actions-unique">
            <button
              type="button"
              onClick={onClose}
              className="donate-registration-modal-cancel-btn-unique"
            >
              취소
            </button>
            <button
              type="submit"
              className="donate-registration-modal-submit-btn-unique"
            >
              등록
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DonateRegistrationModal; 